import { useEffect, useState } from "react";
import ServiceProvider from "../../../configuration/ServiceProvider";
import useBrands from "../../../../explorer/hooks/useBrands";
import { Site } from "../../../../explorer/types/SpareParts";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";
import { Box, Skeleton, Typography } from "@mui/material";
import useCurrentSite from "../../../hook/useCurrentSite";
import { useFormClasses } from "./CreateOfferOrderForm.style";

type InvoicesAddressProps = {
    value?: any;
};
//

export const InvoicesAddress = (props: InvoicesAddressProps) => {
    const [site, setSite] = useState<Site>();
    const [loading, setLoading] = useState<boolean>(true);

    const { t } = useTranslation();
    const brand = useBrands().currentBrandUrl;
    const [currentSite, setCurrentSite] = useCurrentSite();

    useEffect(() => {
        if (props.value === undefined) {
            ServiceProvider.OrderOffer.getInvoicesAddress(brand)
                .then((result) => {
                    setSite(result)
                    setLoading(false);
                })
                .catch((e) => console.error(e));
        }else{
            setLoading(false);
            const initialItems: Site = {
                customerSiteCode: props.value.billToCode,
                customerCode: props.value.billToDto.customer,
                address: props.value.billToDto.address,
                city: props.value.billToDto.city,
                zipCode: props.value.billToDto.zipCode,
                country: props.value.billToDto.country,
                customerSiteName: props.value.billToDto.customerName,

                // Add other fields as necessary
            };
            setSite(initialItems);
        }
    }, []);

     const classesForm=useFormClasses();
    return (
        <>
            {loading ? (
                <Skeleton />
            ) : site !== undefined ? (
                <>
                    <Typography sx={classesForm.title}>
                        {t("orderoffer.invoicesAddress")}
                    </Typography>
                    <Typography sx={classesForm.text}>
                        {site.customerSiteCode}-{site?.customerSiteName} <br />
                        {site.address +
                            " " +
                            site.city +
                            ", " +
                            site.zipCode +
                            " " +
                            site.country}
                    </Typography>
                </>
            ) : (
                <Box>{t("common.noitem")}</Box>
            )}
        </>
    );
};


